<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="类型" prop="dynamicCategoryId" >
        <a-tree-select
          v-if="categoryList.length"
          v-model="form.dynamicCategoryId"
          style="width: 100%"
          :replaceFields="replaceFields"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="categoryList"
          placeholder="请选择分类"
          tree-default-expand-all>
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="机构名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入机构名称" />
      </a-form-model-item>
      <a-form-model-item label="主图" prop="ownerPicture" >
        <file-upload type="image" :defaultList="form.imgArr1" :count="form.ownerPictureCount"
                     @input="getImg($event, 'ownerPicture')"></file-upload>

      </a-form-model-item>
      <a-form-model-item label="背景图" prop="background" >
        <file-upload type="image" :defaultList="form.imgArr2" :count="form.backgroundCount"
                     @input="getImg($event, 'background')"></file-upload>

      </a-form-model-item>
      <a-form-model-item label="机构图片" prop="picture" >
        <file-upload type="image" :defaultList="form.imgArr" :count="5" @click=""
                     @input="getImg($event, 'picture')"  ></file-upload>

      </a-form-model-item>
      <a-form-model-item label="机构介绍" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入联系电话" />
      </a-form-model-item>
      <a-form-model-item label="营业时间" prop="hours" >
        <a-input v-model="form.hours" placeholder="请输入营业时间" />
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="address" >
        <a-input v-model="form.address" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="人均金额" prop="money" >
        <a-input v-model="form.money" placeholder="请输入人均金额" />
      </a-form-model-item>
<!--      <a-form-model-item label="经度" prop="longitude" >-->
<!--        <a-input v-model="form.longitude" placeholder="请输入经度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="纬度" prop="latitude" >-->
<!--        <a-input v-model="form.latitude" placeholder="请输入纬度" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrganization, addOrganization, updateOrganization } from '@/api/organization/organization'
import { listCategory } from '@/api/dynamic/category'
import Editor from '@/components/Editor'
import {guid} from "@/api/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      categoryList: [],
      replaceFields: {
        title: 'categoryName',
        key: 'id',
        value: 'id',
        children: 'children'
      },
      // 表单参数
      form: {
        id: null,
        imgArr: [],
        imgArr1: [],
        imgArr2: [],

        dynamicCategoryId: null,

        name: null,

        ownerPicture: null,
        ownerPictureCount: 1,

        background: null,
        backgroundCount: 1,

        picture: null,
        pictureCount: 9,

        content: null,

        mobile: null,

        hours: null,

        address: null,

        money: null,

        longitude: null,

        latitude: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // dynamicCategoryId: [
        //   { required: true, message: '类型id,外键{zb_dynamic_category.id}不能为空', trigger: 'blur' }
        // ],
        name: [
          { required: true, message: '机构名称不能为空', trigger: 'blur' }
        ]
        // ownerPicture: [
        //   { required: true, message: '主图不能为空', trigger: 'blur' }
        // ],
        // background: [
        //   { required: true, message: '背景图不能为空', trigger: 'blur' }
        // ],
        // picture: [
        //   { required: true, message: '机构图片不能为空', trigger: 'blur' }
        // ],
        // content: [
        //   { required: true, message: '机构介绍不能为空', trigger: 'blur' }
        // ],
        // mobile: [
        //   { required: true, message: '联系电话不能为空', trigger: 'blur' }
        // ],
        // hours: [
        //   { required: true, message: '营业时间不能为空', trigger: 'blur' }
        // ],
        // money: [
        //   { required: true, message: '人均金额不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getCategoryList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 获取分类列表
    getCategoryList() {
      listCategory().then(response => {
        if (response && response.data) {
          // 如果接口已经返回树形结构（有children字段），直接使用
          // 否则转换为树形结构
          if (response.data.length > 0 && response.data[0].children !== undefined) {
            this.categoryList = response.data
          } else {
            // 将平铺数据转换为树形结构
            this.categoryList = this.buildTree(response.data)
          }
        }
      }).catch(err => {
        console.error('获取分类列表失败:', err)
      })
    },
    // 将平铺数据转换为树形结构
    buildTree(data) {
      if (!data || !Array.isArray(data)) {
        return []
      }
      // 创建id映射
      const map = {}
      const roots = []

      // 第一遍：创建所有节点的映射
      data.forEach(item => {
        map[item.id] = { ...item, children: [] }
      })

      // 第二遍：构建树形结构
      data.forEach(item => {
        const node = map[item.id]
        if (item.pid === null || item.pid === 0 || item.pid === undefined) {
          // 根节点
          roots.push(node)
        } else {
          // 子节点
          const parent = map[item.pid]
          if (parent) {
            parent.children.push(node)
          } else {
            // 如果找不到父节点，也作为根节点
            roots.push(node)
          }
        }
      })

      return roots
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        dynamicCategoryId: null,
        name: null,
        ownerPicture: null,
        ownerPictureCount: 1,
        background: null,
        backgroundCount: 1,
        picture: null,
        pictureCount: 9,
        content: null,
        mobile: null,
        hours: null,
        address: null,
        money: null,
        longitude: null,
        latitude: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          console.log("多图", imgArr)
          if (imgArr.length) {
            console.log("来过了", imgArr)
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrganization({"id":id}).then(response => {
        this.form = response.data
        let that = this;
        //数据回显
        this.form.imgArr = []
        that.form.picture.split(",").map(item => {
          this.form.imgArr.push({
            uid: guid(8, 10),
            name: item,
            status: 'done',
            halfUrl: item,
            url: item,
            path: item
          })
        })


        this.form.imgArr1 = []
        this.form.imgArr1.push({
          uid: guid(8, 10),
          name: that.form.ownerPicture,
          status: 'done',
          halfUrl: that.form.ownerPicture,
          url: that.form.ownerPicture,
          path: that.form.ownerPicture
        })
        this.form.imgArr2 = []
        this.form.imgArr2.push({
          uid: guid(8, 10),
          name: that.form.background,
          status: 'done',
          halfUrl: that.form.background,
          url: that.form.background,
          path: that.form.background
        })

        // this.form.imgArr2 = this.setImgData('background', this.form.background)
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrganization(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrganization(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
